.formStack {
  width: 100%;
  display: grid;
  gap: 12px;
}

/* LastUsedPill is positioned outside the SSO button bounds. */
.ssoButtonContainer {
  position: relative;
  width: 100%;
}

.separator {
  width: 100%;
  height: 1px;
  border: 0;
  margin: 0;
  background: var(--t-background-transparent-light);
}

.credentialForm {
  display: grid;
  gap: 12px;
}

.loginFooter {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}

.supportText {
  margin: 0;
  color: var(--foreground-tertiary);
  font-size: var(--font-size-sm);
  line-height: 1.5;
  text-align: center;
}

.formError {
  margin: 0;
  color: var(--destructive);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: 1.4;
  text-align: center;
}

.actionRow {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: center;
}

.loadingStack {
  align-items: center;
  color: var(--foreground-tertiary);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  justify-content: center;
  margin-bottom: var(--spacing-8);
  margin-top: var(--spacing-8);
  min-height: 56px;
  width: 100%;
}

.loadingLabel {
  color: var(--muted-foreground);
  font-size: var(--font-size-sm);
  line-height: 1.5;
  margin: 0;
  text-align: center;
}

@media (max-width: 768px) {
  .formStack {
    gap: 14px;
  }

  .formError {
    font-size: var(--font-size-body);
  }

  .supportText {
    font-size: var(--font-size-body);
  }
}
